import ContentLoader from 'react-content-loader';
import styled, { useTheme } from 'styled-components';
import { PHONE_MEDIA_QUERY } from '../../../common/responsive.js';
import WidthContainer from '../../../components/WidthContainer/index.tsx';

const DemoContainer = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const ContentRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  width: 100%;

  @media ${PHONE_MEDIA_QUERY} {
    grid-template-columns: 1fr;
  }
`;

const Line = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.border.primary};
`;

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-end;
  flex: 1;
`;

const GiftCardContainer = styled.div`
  width: 100%;
  max-width: 407px;
`;

const TokenInfoContainer = styled.div`
  width: 100%;
  max-width: 407px;
`;

const SwapInputsContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const InputContainer = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const SummaryContainer = styled.div`
  width: 100%;
  margin-top: 20px;
`;

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  justify-content: flex-end;
  margin-top: 20px;
`;

const CreateGiftSkeleton = () => {
  const theme = useTheme();
  return (
    <WidthContainer>
      <DemoContainer>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            width: '100%',
            marginBottom: '24px',
          }}
        >
          <ContentLoader
            speed={2}
            width={80}
            height={24}
            viewBox='0 0 80 24'
            backgroundColor={`${theme.background.secondary}`}
            foregroundColor={`${theme.special.skeleton}`}
          >
            <rect x='0' y='0' rx='4' ry='4' width='80' height='24' />
          </ContentLoader>
        </div>
        <ContentRow>
          <GiftCardContainer>
            <ContentLoader
              speed={2}
              width={407}
              height={250}
              viewBox='0 0 407 250'
              backgroundColor={`${theme.background.secondary}`}
              foregroundColor={`${theme.special.skeleton}`}
            >
              <rect x='0' y='0' rx='16' ry='16' width='407' height='250' />
            </ContentLoader>
          </GiftCardContainer>
          <TokenInfoContainer>
            <ContentLoader
              speed={2}
              width={407}
              height={250}
              viewBox='0 0 407 250'
              backgroundColor={`${theme.background.secondary}`}
              foregroundColor={`${theme.special.skeleton}`}
            >
              <rect x='0' y='0' rx='16' ry='16' width='407' height='250' />
            </ContentLoader>
          </TokenInfoContainer>
        </ContentRow>
        <Line />
        <ContentRow>
          <div style={{ width: '100%' }}>
            <ContentLoader
              speed={2}
              width={407}
              height={250}
              viewBox='0 0 407 250'
              backgroundColor={`${theme.background.secondary}`}
              foregroundColor={`${theme.special.skeleton}`}
            >
              <rect x='0' y='0' rx='16' ry='16' width='407' height='250' />
            </ContentLoader>
          </div>
          <FormContainer>
            <SwapInputsContainer>
              <ContentLoader
                speed={2}
                width={407}
                height={120}
                viewBox='0 0 407 120'
                backgroundColor={`${theme.background.secondary}`}
                foregroundColor={`${theme.special.skeleton}`}
              >
                <rect x='0' y='0' rx='8' ry='8' width='407' height='120' />
              </ContentLoader>
            </SwapInputsContainer>
            <InputContainer>
              <ContentLoader
                speed={2}
                width={407}
                height={60}
                viewBox='0 0 407 60'
                backgroundColor={`${theme.background.secondary}`}
                foregroundColor={`${theme.special.skeleton}`}
              >
                <rect x='0' y='0' rx='8' ry='8' width='407' height='60' />
              </ContentLoader>
            </InputContainer>
            <InputContainer>
              <ContentLoader
                speed={2}
                width={407}
                height={60}
                viewBox='0 0 407 60'
                backgroundColor={`${theme.background.secondary}`}
                foregroundColor={`${theme.special.skeleton}`}
              >
                <rect x='0' y='0' rx='8' ry='8' width='407' height='60' />
              </ContentLoader>
            </InputContainer>
            <SummaryContainer>
              <ContentLoader
                speed={2}
                width={407}
                height={120}
                viewBox='0 0 407 120'
                backgroundColor={`${theme.background.secondary}`}
                foregroundColor={`${theme.special.skeleton}`}
              >
                <rect x='0' y='0' rx='8' ry='8' width='407' height='120' />
              </ContentLoader>
            </SummaryContainer>
            <ButtonContainer>
              <ContentLoader
                speed={2}
                width={120}
                height={48}
                viewBox='0 0 120 48'
                backgroundColor={`${theme.background.secondary}`}
                foregroundColor={`${theme.special.skeleton}`}
              >
                <rect x='0' y='0' rx='8' ry='8' width='120' height='48' />
              </ContentLoader>
              <ContentLoader
                speed={2}
                width={120}
                height={48}
                viewBox='0 0 120 48'
                backgroundColor={`${theme.background.secondary}`}
                foregroundColor={`${theme.special.skeleton}`}
              >
                <rect x='0' y='0' rx='8' ry='8' width='120' height='48' />
              </ContentLoader>
            </ButtonContainer>
          </FormContainer>
        </ContentRow>
      </DemoContainer>
    </WidthContainer>
  );
};

export default CreateGiftSkeleton;
